import { productApi } from '@api/product.api';
import { FacetGroup, FacetsResponse } from '@api/types';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

// INITIAL STATE
export type CatalogState = {
  filters?: FacetGroup[];
  categoryLink?: string;
  isWorking?: boolean;
  isInitialWorking?: boolean;
  isFiltersWorking?: boolean;
  breadcrumbs?: Array<{ displayName?: string; url?: string }>;
};

const initialState: CatalogState = {};

// REDUCERS
export const catalogSlice = createSlice({
  name: 'catalog',
  initialState,
  reducers: {
    setCategoryLink: (state, action: PayloadAction<string>) => {
      state.categoryLink = action.payload;
    },
    setCategoryWorking: (state, action: PayloadAction<boolean>) => {
      state.isWorking = action.payload;
    },
    setCategoryInitialWorking: (state, action: PayloadAction<boolean>) => {
      state.isInitialWorking = action.payload;
    },
    setCategoryFiltersWorking: (state, action: PayloadAction<boolean>) => {
      state.isFiltersWorking = action.payload;
    },
    setCategoryBreadcrumbs: (
      state,
      action: PayloadAction<Array<{ displayName?: string; url?: string }>>
    ) => {
      state.breadcrumbs = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      productApi.endpoints.getProductFacets.matchFulfilled,
      (state, action: PayloadAction<FacetsResponse>) => {
        if (action.payload.data) {
          return {
            ...state,
            filters: action.payload.data.filter((filter) => (filter.facets?.length ?? 0) > 0),
          };
        }
      }
    );
  },
});

// ACTIONS
export const {
  setCategoryLink,
  setCategoryWorking,
  setCategoryInitialWorking,
  setCategoryFiltersWorking,
  setCategoryBreadcrumbs,
} = catalogSlice.actions;

// SELECTORS

export const getFacetGroups = createSelector(
  (state: RootState) => state.catalog,
  (facetGroups) => facetGroups
);

export default catalogSlice.reducer;
